import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";
import TraductionArticleService from "@/integrations/service/traduction-article.service";

export const useTraductionsArticle = (articleId: number) => {
  return useQuery({
    queryKey: queryKeys.traductionArticle(articleId),
    queryFn: () => TraductionArticleService.getAll(articleId),
    enabled: !!articleId,
  });
};

export const useCreateTraductionArticle = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ articleId, payload }: { articleId: number; payload: any }) =>
      TraductionArticleService.create(articleId, payload),
    onSuccess: (_, variables) => {
      qc.invalidateQueries({ queryKey: queryKeys.traductionArticle(variables.articleId) });
      qc.invalidateQueries({ queryKey: queryKeys.articles });
    },
  });
};

export const useUpdateTraductionArticle = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: any }) =>
      TraductionArticleService.update(id, payload),
    onSuccess: () => {
      // Invalider toutes les traductions d'articles (on ne connaît pas l'articleId ici)
      qc.invalidateQueries({ queryKey: ["traductions-article"] });
      qc.invalidateQueries({ queryKey: queryKeys.articles });
    },
  });
};

export const useDeleteTraductionArticle = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => TraductionArticleService.delete(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["traductions-article"] });
      qc.invalidateQueries({ queryKey: queryKeys.articles });
    },
  });
};
